import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";
import AvatarEditor from "../../Components/Forms/AvatarEditor";
import L from 'leaflet';
import SubmittingDialog from "../../Components/Loading/SubmittingDialog";

// Libraries
import Form from "react-bootstrap/Form";

import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.js";


export default function CreateCustomer() {
    const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [formErrors, setFormErrors] = useState({ firstName: "" });
    const [form, setForm] = useState({ typeOfFarm: [], accountNumbers: [], contacts: [] });
    const [isValid, setIsValid] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [selectedTypeOfFarm, setSelectedTypeOfFarm] = useState("Arable");

    // Account Numbers
    const [suppliers, setSuppliers] = useState([]);
    const [agents, setAgents] = useState([]);

    // Load suppliers
    useEffect(() => {
        

        axios
            .get(`https://${process.env.REACT_APP_IP}/api/suppliers/`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Suppliers:", res.data);
                setSuppliers(res.data);

            })
            .catch((err) => {
                console.log(err);


                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            });


        axios
            .get(`https://${process.env.REACT_APP_IP}/api/users/`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Agents:", res.data);
                setAgents(res.data);

            })
            .catch((err) => {
                console.log(err);


                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            });

    }, [])




    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    useEffect(() => {

        if (isValid) {
            setSubmitting(true);
            axios
                .post(`https://${process.env.REACT_APP_IP}/api/customers/`, form, { headers: { Authorization: `bearer ${user.token}` } })
                .then((res) => {
                    console.log("response:", res);
                    setSubmitting(false);

                    if (res.status === 200) {
                        navigate(`/Customers/View/${res.data.id}`)
                    }
                })
                .catch((err) => {
                    console.log(err.response.data);
                    setSubmitting(false);



                    if (err.code === "ERR_NETWORK") {
                        setFormErrors({ general: "Connection to the server could not be established. Please try again in a few minutes" });
                    }
                    else if (err.code === "ERR_BAD_REQUEST") {
                        setFormErrors(err.response.data.errors);
                    }
                    else if (err.response.status === 401) {
                        dispatch({ type: "LOGOUT" })
                        navigate("../")
                    }
                    else {
                        setFormErrors({ general: "An unknown error occured. " + err.code });
                    }
                });
        }
    }, [isValid]);

    useEffect(() => {
        setIsValid(formErrors.name === "" && formErrors.accountNumbers === "")
    }, [formErrors])

    const handleSubmit = (event) => {
        event.preventDefault();

        setFormErrors({
            name: form.name === undefined || form.name === "" ? "Company name is required" : "",
            accountNumbers: form.accountNumbers.filter(
                                    item =>
                                    (item.supplierId === undefined || item.supplierId === 0) &&
                                    item.deleted === false
                                    ).length > 0
                                ? "Please select a supplier for each account code"
                                : "",
        });

        
    }


    
    const handleInputChange = (index, field, value) => {
        console.log("changing " + field)

        const updatedItems = form.accountNumbers.map((item, i) =>
            i === index ? {
                ...item,
                [field]: value,
            } : item
        );
        setField("accountNumbers", updatedItems);

    };

    const handleContactsChange = (index, field, value) => {
        console.log("changing " + field)

        const updatedItems = form.contacts.map((item, i) =>
            i === index ? {
                ...item,
                [field]: value,
            } : item
        );
        setField("contacts", updatedItems);

    };

    const handleAddRow = () => {
        console.log("add row")
        setField("accountNumbers", [...form.accountNumbers, { number: "", supplierId: 0,  deleted: false }]);
    }

    const handleAddContacts = () => {
        console.log("add row")
        setField("contacts", [...form.contacts, { name: "", role: "", phone: "", email: "", deleted: false }]);
    }

    const handleAddTypeOfFarm = () => {
        if (!selectedTypeOfFarm) return;

        setForm(prev => ({
            ...prev,
            typeOfFarm: prev.typeOfFarm.includes(selectedTypeOfFarm)
                ? prev.typeOfFarm
                : [...prev.typeOfFarm, selectedTypeOfFarm]
        }));
    };

    const handleRemoveTypeOfFarm = (itemToRemove) => {
        console.log("remove typeoffarm")
        setField("typeOfFarm", form.typeOfFarm.filter(item => item !== itemToRemove));
    }


    return (
        <div className="page">

            {submitting && (
                <SubmittingDialog />
            )}

            <div className="row">
                <div className="col-12">
                    <h1>
                      Create Customer
                    </h1>
                </div>
            </div>

            <Form onSubmit={handleSubmit} noValidate >

            
            <div className="row">
                {/* Customer Details */}
                <div className="col-md-6">
                    <h3>Customer Details</h3>

                    { /* Account Code */}
                    <div className="row">
                        <div className="col-md-6">

                            <div className="form-group">
                                <label>Account Code</label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="e.g ABC123"
                                    isInvalid={formErrors && formErrors.code}
                                    onChange={(e) => setField("code", e.target.value)}
                                    value={form.code ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.code}
                                </Form.Control.Feedback>
                            </div>
                        </div>

                    </div>

                   { /* Company Name */}
                    <div className="row">
                        <div className="col-md-12">
                            
                            <div className="form-group">
                                <label>Company Name</label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="e.g John Smith Farms Ltd"
                                    isInvalid={formErrors && formErrors.name}
                                    onChange={(e) => setField("name", e.target.value)}
                                    value={form.name ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.name}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        
                    </div>

                    { /* Farm Name */}
                    <div className="row">
                        <div className="col-md-12">

                            <div className="form-group">
                                <label>Farm Name</label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="e.g John Smiths Farm"
                                    isInvalid={formErrors && formErrors.farm}
                                    onChange={(e) => setField("farm", e.target.value)}
                                    value={form.farm ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.farm}
                                </Form.Control.Feedback>
                            </div>
                        </div>

                    </div>

                   
                    { /* Address */}
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Billing Address</label>
                                <Form.Control as="textarea" rows="5"
                                    placeholder="e.g Suite 12B"
                                    isInvalid={formErrors && formErrors.billingAddress}
                                    onChange={(e) => setField("billingAddress", e.target.value)}
                                    value={form.billingAddress ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.billingAddress}
                                </Form.Control.Feedback>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Delivery Address</label>
                                <Form.Control as="textarea" rows="5"
                                    placeholder="e.g Suite 12B"
                                    isInvalid={formErrors && formErrors.deliveryAddress}
                                    onChange={(e) => setField("deliveryAddress", e.target.value)}
                                    value={form.deliveryAddress ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.deliveryAddress}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                    { /* Postcode */}
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Postcode</label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g CA1 1AA"
                                    isInvalid={formErrors && formErrors.billingPostcode}
                                    onChange={(e) => setField("billingPostcode", e.target.value)}
                                    value={form.billingPostcode ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.billingPostcode}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Postcode</label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g CA1 1AA"
                                    isInvalid={formErrors && formErrors.deliveryPostcode}
                                    onChange={(e) => setField("deliveryPostcode", e.target.value)}
                                    value={form.deliveryPostcode ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.deliveryPostcode}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                    { /* Telephone */}
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Telephone</label>
                                <Form.Control
                                    type="tel"
                                    placeholder="e.g 01228 123456"
                                    isInvalid={formErrors && formErrors.telephone}
                                    onChange={(e) => setField("telephone", e.target.value)}
                                    value={form.telephone ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.telephone}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                   

                    { /* Email */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Email</label>
                                <Form.Control
                                    required
                                    type="email"
                                    placeholder="e.g john@smith.com"
                                    isInvalid={formErrors && formErrors.email}
                                    onChange={(e) => setField("email", e.target.value)}
                                    value={form.email ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.email}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>    
                </div>

                {/* Other Details */}
                <div className="col-md-6">
                    <h3>Other Details</h3>
                    { /* VAT Number */}
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>VAT Number</label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g CA1 1AA"
                                    isInvalid={formErrors && formErrors.vatNumber}
                                    onChange={(e) => setField("vatNumber", e.target.value)}
                                    value={form.vatNumber ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.vatNumber}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                        { /* Type Of Farm */}
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group select">
                                    <label>Type Of Farm</label>

                                    <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                                        {form.typeOfFarm && form.typeOfFarm.map((item, i) =>
                                            <li key={i} style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                width: "100%",
                                                padding: "4px 8px",
                                                border: "1px solid #ddd",
                                                borderRadius: "6px",
                                                marginBottom: "4px",
                                            }}>{item} <button type="button" className="btn btn-other" onClick={() => handleRemoveTypeOfFarm(item)}>X</button></li>
                                        )}
                                    </ul>



                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                        }}
                                    >
                                        <Form.Select
                                            onChange={(e) => setSelectedTypeOfFarm(e.target.value)}
                                            style={{ flex: 1 }}
                                        >
                                            <option>Arable</option>
                                            <option>Beef</option>
                                            <option>Dairy</option>
                                        </Form.Select>

                                        <button type="button" onClick={handleAddTypeOfFarm} className="btn btn-primary">
                                            +
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        { /* Assigned Agent */}
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group select">
                                    <label>Assigned Agent</label>

                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                        }}
                                    >
                                        <Form.Select
                                            onChange={(e) => setField("assignedAgentId", e.target.value)}
                                            style={{ flex: 1 }}
                                        >
                                            <option value="0">No Agent Assigned</option>
                                            {agents && (agents.map((agent) => {
                                                return <option key={agent.id} value={agent.id}>{agent.name}</option>
                                            }))}   
                                        </Form.Select>

                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                    { /* Info Pack Received */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <Form.Check
                                    type="checkbox"
                                    isInvalid={formErrors && formErrors.infoPackReceived}
                                        onChange={(e) => setField("infoPackReceived", e.target.checked)}
                                        checked={form.infoPackReceived ? true : false}
                                    label="Info Pack Received"/>
                                    
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.infoPackReceived}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                    { /* Marketing Consent */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <Form.Check
                                    type="checkbox"
                                    isInvalid={formErrors && formErrors.marketingConsent}
                                    onChange={(e) => setField("marketingConsent", e.target.checked)}
                                    checked={form.marketingConsent ? true : false}
                                    label="Marketing Consent?" />

                                <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.marketingConsent}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                    { /* Notes */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Notes</label>
                                <Form.Control as="textarea" rows="5"
                                    placeholder="e.g Only orders large bags"
                                    isInvalid={formErrors && formErrors.notes}
                                    onChange={(e) => setField("notes", e.target.value)}
                                    value={form.notes ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.notes}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="col-md-6">


                                <h3>Account Numbers</h3>

                                <div className="row">
                                    <div className="col-12">

                                        <table width="100%">
                                            <thead>
                                                <tr>
                                                    <td>Invoice Account</td>
                                                    <td>Delivery Account</td>
                                                    <td>Supplier</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {form.accountNumbers && form.accountNumbers.map((item, index) => (
                                                    <tr style={{ display: item.deleted ? "none" : "" }} key={index}>
                                                        {/* Invoice Account Number */}
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                value={item.invoiceAccountNumber}
                                                                onChange={e => handleInputChange(index, 'invoiceAccountNumber', e.target.value)}
                                                            />
                                                        </td>
                                                        {/* Delivery Account Number */}
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                value={item.deliveryAccountNumber}
                                                                onChange={e => handleInputChange(index, 'deliveryAccountNumber', e.target.value)}
                                                            />
                                                        </td>
                                                        {/* Supplier */}
                                                        <td>
                                                            <div className="select">
                                                                <Form.Select
                                                                    onChange={e => handleInputChange(index, 'supplierId', e.target.value)}
                                                                    value={item.supplierId}
                                                                >
                                                                    <option value="0" >Please Select...</option>
                                                                    {suppliers && (suppliers.map((supplier) => {
                                                                        return <option key={supplier.id} value={supplier.id}>{supplier.name}</option>
                                                                    }))}
                                                                </Form.Select>
                                                            </div>
                                                        </td>
                                                        <td><button type="button" className="btn btn-other" onClick={() => { handleInputChange(index, 'deleted', true) }}>X</button></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>


                                        {formErrors.accountNumbers && (<div className="alert alert-warning">{formErrors.accountNumbers}</div>)}
                                        <button type="button" className="btn btn-primary" onClick={handleAddRow}>Add Item</button>
                                    </div>
                                </div>



                </div>
            </div>

            
                <div className="row">
                    <div className="col-md-12">
                        <h3>Contacts</h3>

                        <div className="row">
                            <div className="col-12">

                                <table width="100%">
                                    <thead>
                                        <tr>
                                            <td>Name</td>
                                            <td>Role</td>
                                            <td>Phone</td>
                                            <td>Email</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {form.contacts && form.contacts.map((item, index) => (
                                            <tr style={{ display: item.deleted ? "none" : "" }} key={index}>
                                                {/* Name */}
                                                <td>
                                                    <Form.Control
                                                        type="text"
                                                        value={item.name}
                                                        onChange={e => handleContactsChange(index, 'name', e.target.value)}
                                                    />
                                                </td>
                                                {/* Role */}
                                                <td>
                                                    <Form.Control
                                                        type="text"
                                                        value={item.role}
                                                        onChange={e => handleContactsChange(index, 'role', e.target.value)}
                                                    />
                                                </td>
                                                {/* Phone */}
                                                <td>
                                                    <Form.Control
                                                        type="text"
                                                        value={item.phone}
                                                        onChange={e => handleContactsChange(index, 'phone', e.target.value)}
                                                    />
                                                </td>
                                                {/* Email */}
                                                <td>
                                                    <Form.Control
                                                        type="text"
                                                        value={item.email}
                                                        onChange={e => handleContactsChange(index, 'email', e.target.value)}
                                                    />
                                                </td>


                                                <td><button type="button" className="btn btn-other" onClick={() => { handleContactsChange(index, 'deleted', true) }}>X</button></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>


                                {formErrors.accountNumbers && (<div className="alert alert-warning">{formErrors.accountNumbers}</div>)}
                                <button type="button" className="btn btn-primary" onClick={handleAddContacts}>Add Item</button>
                            </div>
                        </div>
                    </div>
                </div>
            


            <hr />

            {formErrors.general && (
                <div className="row">
                    <div className="col-md-12">
                        <div className="alert alert-danger">
                                {formErrors.general}
                        </div>
                    </div>
                </div>
            )}

            <div className="row">
                <div className="col-md-12">
                    <button className="btn btn-primary">Create Customer</button>
                    <button className="btn btn-other" style={{ marginLeft: 10 }} onClick={() => { navigate(`/Customers/`) }}>Cancel</button>
                </div>
            </div>
            </Form>

        </div>
  )
}
